// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "." + {"371":"2393ddd0","488":"6bdb6efe","521":"98c5dd2d"}[chunkId] + ".chunk.js"; };